// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const NeedsOut = zod.object({
  "constraints": zod.array(zod.string()),
  "country": zod.union([zod.string(),zod.null()]),
  "industry": zod.union([zod.string(),zod.null()]),
  "needs": zod.array(zod.string()),
  "summary": zod.string()
});

export type NeedsOut = zod.input<typeof NeedsOut>;
export type NeedsOutOutput = zod.output<typeof NeedsOut>;
